export default {
  data() {
    const LCInfoSchema = [
      {
        label: 'Amendment Number',
        type: 'input',
        key: 'amendmentNumber',
      },
      {
        label: 'Amendment Date(YYYY-MM-DD)',
        type: 'date',
        key: 'amendmentDate',
      },
      {
        label: 'Allow Partial Shipment',
        type: 'checkbox',
        key: 'allowPartialShipment',
      },
      {
        label: 'Amendment',
        type: 'checkbox',
        key: 'amendment',
      },
    ]
    return {
      LCInfoSchema,
    }
  },
}
